import * as React from 'react';
import { useMemo } from 'react';
var messages = {
  moveToday: 'Today',
  moveBack: 'Navigate back',
  moveForward: 'Navigate forward',
  dateButton: 'Select date',
  openCombobox: 'open combobox',
  emptyList: 'There are no items in this list',
  emptyFilter: 'The filter returned no results',
  createOption: function createOption(_value, searchTerm) {
    return [' Create option', searchTerm && ' ', searchTerm && /*#__PURE__*/React.createElement("strong", {
      key: "_"
    }, "\"".concat(searchTerm, "\""))];
  },
  tagsLabel: 'Selected items',
  removeLabel: 'Remove selected item',
  noneSelected: 'no selected items',
  selectedItems: function selectedItems(labels) {
    return "Selected items: ".concat(labels.join(', '));
  },
  // number
  increment: 'Increment value',
  decrement: 'Decrement value'
};
var DEFAULTS = {};
export function getMessages() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS;
  var processed = {};
  Object.keys(messages).forEach(function (message) {
    var value = defaults[message];
    if (value == null) value = messages[message];
    processed[message] = typeof value === 'function' ? value : function () {
      return value;
    };
  });
  return processed;
}
export var useMessagesWithDefaults = function useMessagesWithDefaults(defaults) {
  return useMemo(function () {
    return getMessages(defaults);
  }, [defaults]);
};